import FilterModal from './FilterModal';
import { useDispatch } from 'react-redux';
import { setModalId, usePublicState } from '@/store/slices/publicSlice';
import Search from '@/components/categories/Search';
import { useLazyGetOrdersReportFileQuery } from '@/store/services/reports';
import FilterBtn from '../SharedComponents/FilterBtn';
import ExportBtn from '../SharedComponents/ExportBtn';
import { useOrdersFilters } from '@/store/slices/reportFiltersSlice';

export function Filters() {
  const dispatch = useDispatch();
  const filters = useOrdersFilters();
  const { search } = usePublicState();

  const searchValue = search?.ordersReportSearch || '';

  return (
    <div className="flex items-center justify-between flex-col md:flex-row gap-4">
      <Search searchName="ordersReportSearch" />

      <div className="flex items-center gap-4">
        <FilterBtn
          onClick={() => {
            dispatch(setModalId({ id: 'ORDERS_REPORT_MODAL' }));
          }}
        />

        <ExportBtn
          useQueryHook={useLazyGetOrdersReportFileQuery}
          filters={{ ...filters, search: searchValue }}
        />
      </div>

      <FilterModal />
    </div>
  );
}

